/* import { useState } from "react";
import { useNavigate } from "react-router-dom";
import TopNav from "../../home/components/TopNav";
import HeroSection from "./components/HeroSection";
import CoreFeatures from "./components/CoreFeatures";
import DataDashboard from "./components/DataDashboard";
import UseCases from "./components/UseCases";
import PricingSection from "./components/PricingSection";

export default function EnterpriseInsightPage() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <TopNav />
      <div className="pt-14">
        <HeroSection />
        <CoreFeatures />
        <DataDashboard />
        <UseCases />
        <PricingSection />
      </div>
    </div>
  );
} */
import { useState, useRef, useEffect } from 'react';
import TopNav from "../../home/components/TopNav";
export default function EmbeddedContentPage() {
  const [iframeUrl] = useState<string>('http://49.4.7.179:8089/shangke/map-view/embed');
  const [loading, setLoading] = useState<boolean>(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleIframeLoad = () => {
    // 添加一个小的延迟来确保内容完全渲染
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  // 如果长时间没有加载完成，强制显示
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (loading) {
        setLoading(false);
      }
    }, 10000); // 10秒超时

    return () => clearTimeout(timeoutId);
  }, [loading]);

  return (
    <div className="w-screen h-screen overflow-hidden">
      <TopNav />

      {/* 加载状态 - 简约美观样式 */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/90 z-40 backdrop-blur-sm">
          <div className="text-center">
            <div className="w-8 h-8 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin mx-auto mb-3"></div>
            <div className="text-slate-600 text-sm font-medium">加载中...</div>
          </div>
        </div>
      )}

      {/* iframe 从顶部导航下方开始 */}
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        className="w-full h-full border-0 pt-[56px]"
        onLoad={handleIframeLoad}
        style={{ visibility: loading ? 'hidden' : 'visible' }}
      />
    </div>
  );
}
